export function isOnlineGameEvent(event) {
  const type = String(event?.event_type || "").trim().toLowerCase();
  // Physical events also inherit digital catalog defaults from EventCreate.
  // Their explicit modality must win over those legacy metadata fields.
  if (type === "presencial") return false;
  if (type === "online") return true;
  return event?.catalog_section === "special"
    || event?.catalog_section === "premium"
    || Boolean(event?.special_game_active)
    || Boolean(event?.quiz_maker_quiz_id);
}
